var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('app-echart-stacked-area',{attrs:{"option-data":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }